import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatTabsModule } from '@angular/material/tabs'
import { MatTooltipModule } from '@angular/material/tooltip'
import { PipesModule } from '@mmx/pipes'
import { DirectivesModule } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { CodesSelectorInputComponent } from '../codes-selector'
import { CustomFieldsFormComponent } from '../custom-fields-form'
import { DataViewDialogComponent } from '../data-view-dialog'
import { DateFieldModule } from '../date-selector'
import { DiagnosisCodeChipsSelectorComponent } from '../diagnosis-code-chips-selector/diagnosis-code-chips-selector.component'
import { FacilitySelectorModule } from '../facility-selector'
import { FileInputModule } from '../file-input'
import { FormErrorModule } from '../form-error'
import { PriorAuthorizationFormModule } from '../prior-authorization-form'
import { ReferrerSelectorModule } from '../referrer-selector'
import { AuthorizationDialogComponent } from './authorization-dialog.component'
import { AuthClinicalInformationComponent, AuthCptPickerComponent, AuthDetailsFormComponent, AuthStatusDetailsComponent } from './components'

@NgModule({
  imports: [
    CommonModule,
    DateFieldModule,
    FormErrorModule,
    CustomFieldsFormComponent,
    CodesSelectorInputComponent,
    DiagnosisCodeChipsSelectorComponent,
    DirectivesModule,
    MatIconModule,
    MatTabsModule,
    AuthClinicalInformationComponent,
    PriorAuthorizationFormModule,
    ReferrerSelectorModule,
    FacilitySelectorModule,
    TranslateModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    FlexModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatInputModule,
    MatTooltipModule,
    FileInputModule,
    PipesModule,
    AuthStatusDetailsComponent,
    DataViewDialogComponent,
  ],
  declarations: [
    AuthDetailsFormComponent,
    AuthorizationDialogComponent,
    AuthCptPickerComponent,
  ],
})
export class AuthorizationDialogModule {}
